import { useFormikContext } from 'formik';
import * as React from 'react';
import { Picker } from '@react-native-picker/picker';

type DropDownPickerProps = {
  name: string;
  label: string;
  options: any;
  customLabelStyle?: any;
};

export const Dropdown = ({
  name,
  label,
  options,
  customLabelStyle,
}: DropDownPickerProps) => {
  const { setFieldValue, touched, errors, values } = useFormikContext();
  const onPickerChange = React.useCallback(
    (value) => {
      setFieldValue(name, value);
    },
    [name, setFieldValue],
  );
  const [selectedLanguage, setSelectedLanguage] = React.useState<any>();

  return (
    <Picker
      selectedValue={selectedLanguage}
      onValueChange={(itemValue, itemIndex) => setSelectedLanguage(itemValue)}
    >
      <Picker.Item label="Java" value="java" />
      <Picker.Item label="JavaScript" value="js" />
    </Picker>
  );
};
